<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps" style="background-color: #FFF3E0;">
                <v-list-item-title style="color: #FF9800;">
                    <v-icon>mdi mdi-autorenew</v-icon>
                    Nuevo token
                </v-list-item-title>
            </v-list-item>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Ingrese nuevo token" class="modal-header"></v-toolbar>
                <v-container>
                <h3>Por favor ingrese un nuevo token o token 0.</h3>
                <p v-if="datosContacto.telefono">Telefono del afiliado: {{ this.datosContacto.telefono }}</p>
                <p v-if="datosContacto.email">Email del afiliado: {{ this.datosContacto.email }}</p>
                
                <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit" class="mt-4">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                required
                                v-model="token"
                                label="Token"
                                variant="solo"
                                :rules="obligatorioNum"
                                class="asterisco"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions class="justify-end">
                        <v-btn
                            text="Cancelar"
                            :loading="cargando"
                            :disabled="cargando"
                            id="boton-verde"
                            @click="isActive.value = false"
                        ></v-btn>                        
                        <v-btn
                            type="submit"
                            id="boton-verde"
                            :disabled="!valid || cargando"
                            :loading="cargando"
                            text="Autorizar"
                        ></v-btn>
                    </v-card-actions>
                </v-form>
                </v-container>
            </v-card>
        </template>
    </v-dialog>
    <AlertComponent
    :title="alertTitle"
    :text="alertText"
    :alertType="alertType"
    :showAlert="showAlert"
    @close="showAlert = false"
    />
</template>

<style src="../assets/base.css"></style>

<script>
import {obligatorioNumerico} from '@/_helpers/rules';
import PrestacionService from '@/api/PrestacionService';
import AlertComponent from './AlertComponent.vue';

const prestacionService= new PrestacionService();

export default {
    components: {
        AlertComponent
    },
    props: {
        datosContacto: {
            type: Object,
            required: true
        },
        username: {
            type: String,
            required: true
        },
        idSolicitud: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            token: '',
            valid: false,
            cargando: false,
            obligatorioNum : obligatorioNumerico,
            dialog: false,
            alertTitle: '',
            alertText: '',
            alertType:'',
            showAlert:false,
        }
    },
    methods: {
        async handleSubmit(){
            await this.actualizarToken(this.token);
        },
        async actualizarToken(token){
            this.cargando = true;
            const response = await prestacionService.actualizarToken(this.idSolicitud,token,this.username);
            this.cargando = false;
            this.dialog = false;
            this.$emit('tokenActualizado', response);
        },
    }
}
</script>